



















































































































































































































































































































































































































































































































































































































import {
  toRefs,
  ref,
  reactive,
  computed,
  defineComponent
} from "@vue/composition-api";
import { Report, Area, Zone, Location } from "@/interfaces/interfaces";
import { useMainStore } from "@/store/storage";
import { db } from "@/firebase/firebase";
//@ts-ignore
import VueHtml2pdf from "vue-html2pdf";
import ReportTableBody from '@/views/reports/ReportTableBody.vue'
// import SurveyForm from "./SurveyForm.vue";

// import _ from "lodash";

export default defineComponent({
  name: "ReportTable",

  components: {
    VueHtml2pdf,
    ReportTableBody
  },

  setup(props, { root }) {
    const form = (ref(null) as unknown) as HTMLFormElement;

    const state = reactive({
      showArea: "",
      showZone: "",
      itemArea: 0,
      itemZone: 0,
      reportType: "FIL",
      dialog: false,
      formDialog: false,
      valid: false,
      id: "",
      photo: "",
      inspectionArea: "",
      inspectionZone: "",
      inspectionLocation: "",
      description: "",
      primarySecuring: "",
      secondaryRetention: "",
      howToInspect: "",
      condition: "None",
      comments: "",
      control: "",
      reference: "",
      controlchips: ["7 Days", "30 Days", "90 Days", "180 Days"],
      inspectionBookChip: 0,
      tableHeaders: [] as string[],
      tableBody: {},
      tableHeadersHtml: ""
    });

    const html2Pdf = ref(null);

    const main = useMainStore();

    const fbCollections = {
      area: db.collection("InspectionAreas"),
      zone: db.collection("InspectionZones"),
      locations: db.collection("locations"),
      surveys: db
        .collection("projects")
        .doc((main.state.projectData.id as string) || "xxx")
        .collection("reports")
    };

    const projectObject = reactive({
      inspectionAreas: [] as Area[],
      inspectionZones: [] as Zone[],
      locations: [] as Location[],
      projectSurvey: [] as Report[]
    });

    // let projectDataLoaded = {};

    function updateAreas(
      areaCollection: firebase.firestore.CollectionReference,
      zoneCollection: firebase.firestore.CollectionReference,
      locationCollection: firebase.firestore.CollectionReference,
      surveyCollection: firebase.firestore.CollectionReference
    ) {
      // const startProcessing = () => {
      //   const projectData = {
      //     companyName: "xyz Company",
      //     rigName: "TTXGG",
      //     surveys: { areasList: [] }
      //   };
      //   projectData.surveys.areasList = [];

      //   //AREAS
      //   main.orderAreas.value.forEach((item: Area) => {
      //     //ZONES
      //     const zones = [] as Zone[];
      //     main.orderZones.value.forEach((item: Zone) => {
      //       //SURVEYS
      //       const surveys = [] as Report[];
      //       main.orderSurveys.value.forEach((item: Report) => {
      //         surveys.push(item);
      //       });
      //       const content2 = { ...item, surveys: surveys };
      //       //CHECK IF HAS FAILED, SURVEY OR INSPECTION
      //       // if (){
      //       zones.push(content2);
      //       // }
      //     });

      //     const content = { ...item, zones: zones };
      //     projectData.surveys.areasList.push(content);

      //   });

      //   projectDataLoaded = Object.freeze(projectData);

      // };

      const getData = async () => {
        //GET AREA DATA
        const areaDoc = await areaCollection.orderBy("area", "asc").get();
        await areaDoc.forEach((item) => {
          const obj = { id: item.id, ...item.data() } as Area;
          if (!state.showArea) {
            const t = obj.area.toLowerCase().indexOf("area 01");
            if (t > -1) {
              state.showArea = item.id;
            }
          }
          projectObject.inspectionAreas.push(obj);
        });
        main.state.inspectionAreas = projectObject.inspectionAreas;

        //GET ZONE DATA
        const zoneDoc = await zoneCollection.orderBy("zone", "asc").get();
        await zoneDoc.forEach((item) => {
          const obj = { id: item.id, ...item.data() } as Zone;
          if (!state.showZone) {
            const t = obj.zone.toLowerCase().indexOf("zone 1");
            if (t > -1) {
              state.showZone = item.id;
            }
          }
          projectObject.inspectionZones.push(obj);
        });
        main.state.inspectionZones = projectObject.inspectionZones;

        //GET LOCATION DATA
        const locationDoc = await locationCollection
          .orderBy("location", "asc")
          .get();
        await locationDoc.forEach((item) => {
          const obj = { id: item.id, ...item.data() } as Location;
          projectObject.locations.push(obj);
        });
        main.state.locations = projectObject.locations;

        //GET SURVEY DATA

        await surveyCollection
          .orderBy("reference", "asc")
          .onSnapshot((snapshot) => {
            const surveyDoc: Report[] = [];
            snapshot.forEach((item) => {
              surveyDoc.push({ id: item.id, ...item.data() } as Report);
            });
            projectObject.projectSurvey = surveyDoc as Report[];
          });

        // await startProcessing();
      };
      getData();

      // setTimeout(() => {
      //   state.reportType = 'FIL';
      // }, 10000);
    }

    updateAreas(
      fbCollections.area,
      fbCollections.zone,
      fbCollections.locations,
      fbCollections.surveys
    );
    const findZone = (searchid: string): Zone => {
      const obj = {
        id: searchid
      };
      return root.lodash.find(projectObject.inspectionZones, obj) as Zone;
    };
    const findArea = (searchid: string): Area => {
      const obj = {
        id: searchid
      };
      return root.lodash.find(projectObject.inspectionAreas, obj) as Area;
    };
    const findLocation = (searchid: string): Location => {
      const obj = {
        id: searchid
      };
      return root.lodash.find(projectObject.locations, obj) as Location;
    };
    const filterZone = computed(
      (): Zone => {
        const obj = {
          id: state.showZone
        };
        return root.lodash.find(projectObject.inspectionZones, obj) as Zone;
      }
    );
    const filterArea = computed(
      (): Area => {
        const obj = {
          id: state.showArea
        };
        return root.lodash.find(projectObject.inspectionAreas, obj) as Area;
      }
    );
    const filterSurvey = computed((): Report[] => {
      const obj = {
        inspectionArea: state.showArea,
        inspectionZone: state.showZone
      };
      if (state.reportType === "IB")
        //@ts-ignore
        obj.control = state.controlchips[state.inspectionBookChip];

      return root.lodash.filter(projectObject.projectSurvey, obj) as Report[];
    });

    const inspectionBookControl = computed(() => {
      if (state.reportType !== "IB") return "";
      return " - " + state.controlchips[state.inspectionBookChip];
    });
    // if (!state.showArea) {

    //   projectObject.inspectionAreas.forEach(function(result) {
    //     return result;
    //   });
    // }
    // if (!state.showZone) {
    //   state.showArea = projectObject.inspectionZones[0].id;
    // }

    let title = "";
    let pageTitle = "";

    const clientName = main.state.clientData.companyName;
    const rigName = main.state.projectData.rigName;

    function setPageTitle() {
      if (state.reportType === "FIL") {
        title = `<span class="font-weight-bolder">${clientName}</span> <span class="font-weight-light">${rigName}</span> Dropped Object Report
    <br /> DO Failed Items List`;
        pageTitle = `${clientName} - ${rigName} - Dropped Object Report - DO Failed Items List`;
      }

      if (state.reportType === "SR") {
        title = `<span class="font-weight-bolder">${clientName}</span> <span class="font-weight-light">${rigName}</span> Dropped Object Report
     <br /> DO Survey Report`;
        pageTitle = `${clientName} - ${rigName} - Dropped Object Report - DO Survey Report`;
      }

      if (state.reportType === "IB") {
        title = `<span class="font-weight-bolder">${clientName}</span> <span class="font-weight-light">${rigName}</span> Dropped Object Report
      <br /> DO Inspection Book`;
        pageTitle = `${clientName} - ${rigName} - Dropped Object Report - DO Inspection Book`;
      }
    }

    setPageTitle();

    let tHeader = "";
    let tBody = "";

    const headerHtml = computed(() => {
      const reportlist = filterSurvey.value;
      const reportHtml = [] as string[];
      const tDStyle = "padding: 10px 15px; border: 1px solid #777; ";

      if (state.reportType === "FIL") {
        state.tableHeaders = [
          "Photo",
          "Reference",
          "Description/Location",
          "Fastening Method",
          "Condition/Comment"
        ];

        for (const item of reportlist) {
          if (item.condition === 'Fail'){
          reportHtml.push(
            `<tr>
            
            <td style="${tDStyle}">
              <img src="${item.photo}" style="width: 120px; height: auto" @click="printAgain()" />
            </td>
           <td style="${tDStyle}">
            ${item.reference}</td>
            <td style="${tDStyle}">
                <div class="mb-5"> 
                  Description: ${item.description || ""}
                </div>
                <div>
                  Location: ${findLocation(item.inspectionLocation).location}  
                </div>
            </td>
            <td style="${tDStyle}">
              <div class="mb-5">
                  Primary Securing: ${item.primarySecuring || ""}
              </div>
              <div>
                  Secondary Retention: ${item.secondaryRetention || ""}
              </div>  
            </td>
            <td style="${tDStyle}">
              <div class="mb-5">
                Condition: ${item.condition || ""}
              </div>
              <div>
                Comment: ${item.comments || ""}
              </div>
            </td>
            </tr>
            `
          );
          }
        }
      }
      if (state.reportType === "SR") {
        state.tableHeaders = [
          "Photo",
          "Reference",
          "Description/Location",
          "Fastening Method",
          "Condition/Comment",
          "Control"
        ];

        for (const item of reportlist) {
          reportHtml.push(
            `<tr>
            <td><button  v-on:click="printAgain">Print</button></td>
            <td style="${tDStyle}">
             <img src="${item.photo}" style="width: 100px; height: auto" @click="printAgain()" />
            </td>

           <td style="${tDStyle}">
            ${item.reference}</td>

            <td style="${tDStyle}">
                <div class="mb-5"> 
                  Description: ${item.description || ""}
                </div>
                <div>
                  Location: ${findLocation(item.inspectionLocation).location}  
                </div>
            </td>

            <td style="${tDStyle}">
              <div class="mb-5">
                  Primary Securing: ${item.primarySecuring || ""}
              </div>
              <div>
                  Secondary Retention: ${item.secondaryRetention || ""}
              </div>  
            </td>

            <td style="${tDStyle}">
              <div class="mb-5">
                Condition: ${item.condition || ""}
              </div>
              <div>
                Comment: ${item.comments || ""}
              </div>
            </td>
            
            <td style="${tDStyle}">
              <div>
                Comment: ${item.control || ""}
              </div>
            </td>
            </tr>
            `
          );
        }
      }
      if (state.reportType === "IB") {
        state.tableHeaders = [
          "Photo",
          "Reference",
          "Description/Location",
          "Fastening Method",
          "How to Inspect",
          "Signature"
        ];

        for (const item of reportlist) {
          reportHtml.push(
            `
            <tr>
            <td style="${tDStyle}">
              <img src="${item.photo}" style="width: 100px; height: auto" @click="printAgain()" />
            </td>

           <td style="${tDStyle}">
            ${item.reference}</td>

            <td style="${tDStyle}">
                <div class="mb-5"> 
                  Description: ${item.description || ""}
                </div>
                <div>
                  Location: ${findLocation(item.inspectionLocation).location}  
                </div>
            </td>

            <td style="${tDStyle}">
              <div class="mb-5">
                  Primary Securing: ${item.primarySecuring || ""}
              </div>
              <div>
                  Secondary Retention: ${item.secondaryRetention || ""}
              </div>  
            </td>

            <td style="${tDStyle}">
              <div class="mb-5">
                How To Inspect: ${item.howToInspect}
              </div>
              <div class="mb-5">
                Condition: ${item.condition || ""}
              </div>
              <div>
                Comment: ${item.comments || ""}
              </div>
            </td>
            
            <td style="${tDStyle}">
              <div>
                
              </div>
            </td>
            </tr>
            `
          );
        }
      }

      state.tableBody = {
        items: reportlist,
        body: reportHtml
      }

      tHeader = state.tableHeaders
        .map((item) => {
          return `<th  
            style="padding: 15px; 
            border-bottom: 1px solid #777;
            border: 1px solid #777;
            background-color: #0D47A1 ; 
            color: white;
            font-weight: bold
            ">
            ${item}
            </th>`;
        })
        .join("");

      tBody = reportHtml
        .map((item) => {
          return `${item}`;
        })
        .join("");
      const structure = {
        thead: `<thead><tr>${tHeader}</tr></thead>`,
        tbody: `<tbody>${tBody}</tbody>`
      };
      return `<table class="myTable" 
      style="
      font-family: Arial, san-serif; 
      border-collapse: collapse;
      font-size: 12px;
      width: 100%
      ">
      ${structure.thead}
      ${structure.tbody}
      </table>`;
    });

    const compiledData  = computed(()=>{
      return {
        template: headerHtml.value,
        methods:{
          printAgain(){
            console.log('inside')
          }
        }
      }
    })

    interface FilterTitle {
      title: string;
      subtitle: string;
      color: string;
      pageTitle: string;
    }

    const filterTitle = computed(
      (): FilterTitle => {
        setPageTitle();

        if (filterArea.value && filterZone.value) {
          const header = {
            title: title,
            subtitle: `${filterArea.value.area} <br /> ${filterZone.value.zone} - ${filterZone.value.equipmentType} ${inspectionBookControl.value}`,
            color: filterZone.value.color ? filterZone.value.color.hex : "",
            pageTitle: pageTitle
          } as FilterTitle;

          document.title =
            "Westend Diamond - " + pageTitle || "Drop Inpspection";

          return header;
        }
        return { title: "", subtitle: "", color: "", pageTitle: "" };
      }
    );

    function clearItem() {
      state.id = "";
      state.inspectionArea = "";
      state.inspectionZone = "";
      state.inspectionLocation = "";
      state.description = "";
      state.primarySecuring = "";
      state.secondaryRetention = "";
      state.howToInspect = "";
      state.condition = "None";
      state.comments = "";
      state.control = "";
      state.reference = "";

      form.value.reset();
      form.value.resetValidation();
    }

    function addItem() {
      clearItem();
      state.formDialog = true;
    }

    function setItem(e: Report): void {
      state.id = e.id as string;
      state.inspectionArea = e.inspectionArea;
      state.inspectionZone = e.inspectionZone;
      state.inspectionLocation = e.inspectionLocation;
      state.description = e.description || "";
      state.primarySecuring = e.primarySecuring || "";
      state.secondaryRetention = e.secondaryRetention || "";
      state.howToInspect = e.howToInspect || "";
      state.condition = e.condition || "";
      state.comments = e.comments || "";
      state.control = e.control || "";
      state.reference = e.reference;
      state.photo = e.photo as string;
      state.formDialog = true;
    }

    function saveItem(): void {
      if (state.id && state.id.length > 4) {
        const data = {
          inspectionArea: state.inspectionArea,
          inspectionZone: state.inspectionZone,
          inspectionLocation: state.inspectionLocation,
          description: state.description,
          primarySecuring: state.primarySecuring,
          secondaryRetention: state.secondaryRetention,
          howToInspect: state.howToInspect,
          condition: state.condition,
          comments: state.comments,
          control: state.control,
          reference: state.reference,
          photo: state.photo
        };

        fbCollections.surveys
          .doc(state.id)
          .update(data)
          .then(() => {
            state.formDialog = false;
          });
      }
    }
    const areaSelect = computed(() => {
      return main.state.inspectionAreas.map((e: Area) => e.area);
    });
    const zoneSelect = computed(() => {
      return main.state.inspectionZones.map((e: Zone) => e.zone);
    });
    const locationSelect = computed(() => {
      return main.state.locations.map((e: Location) => e.location);
    });
    const mobile = computed(() => {
      return root.$vuetify.breakpoint.mobile;
    });
    const mdAndUp = computed(() => {
      return root.$vuetify.breakpoint.mdAndUp;
    });
    // const theme = computed(() => {
    //   const route = root.$route.params.page;
    //   const theme = {
    //     color: "info",
    //     title: "Reports"
    //   };
    // })

    function print() {
      // Pass the element id here
      //@ts-ignore
      root.$htmlToPaper("printMe", null, () => {
        //
      });
    }

    function createPreview(print = false) {
      const newWindow = window.open("", "", "width=100, height=100") as Window;
      window.scrollTo(0, window.document.body.scrollHeight);

      const document = newWindow.document.open(),
        pageContent = `<!DOCTYPE html>
          <html>
          <head>
          <meta charset="utf-8" />
          <title>Westend Diamond - ${pageTitle}</title>
          <style type="text/css">body {-webkit-print-color-adjust: exact; font-family: Arial; }</style>
          </head>
          <body>
          <div id="printMe">
          <img src="/img/Westend_Diamond_logo.png" alt="">
      <div
        style="padding: 10px 0; display: flex; justify-content: space-between; align-items: center"
      >
        <h2 style="font-size: 20px">${filterTitle.value.title}</h2>
        <!-- <h2 style="font-size: 50px">DO</h2> -->
        <img src="/img/drops_inspection_logo.jpg" alt="" style="height: 90px; width: auto;">
      </div>
      <div
        style="padding: 10px 20px; display: flex; justify-content: space-between; color: white; 
        background-color: ${filterTitle.value.color} "
      >
        <h3 style="font-size: 16px">${filterTitle.value.subtitle}</h3>
      </div>
          ${headerHtml.value}
         
          </body>
          </html>`;
      console.log(pageContent);
      document.write(pageContent);
      document.close();
      newWindow.moveTo(0, 0);
      newWindow.resizeTo(screen.width, screen.height);
      newWindow.scrollTo(0, newWindow.document.body.scrollHeight);

      if (print) {
        setTimeout(function() {
          newWindow.print();
          newWindow.close();
        }, 10000);
      }
    }

    function printAgain() {
      console.log('printing...')
      createPreview(true);
    }
    function preview() {
      createPreview();
    }
    // function outputPdf() {
    //   createPreview();
    // }

    // function generatePdf() {
    //   root.$refs.html2Pdf.generatePdf();
    // }
    function generateReport() {
      console.log(root.$refs.html2Pdf);
      //@ts-ignore
      html2Pdf.value.generatePdf({
        enableLinks: true,
        html2canvas: {
          scale: 1,
          useCORS: true
        }
      });
      // root.$refs.html2Pdf.generatePdf();
    }

    // generateReport()

    return {
      ...toRefs(state),
      main: main.state,
      store: main,
      html2Pdf,
      generateReport,
      // generatePdf,
      projectObject: Object.freeze(projectObject),
      filterArea,
      filterZone,
      filterTitle,
      findZone,
      findArea,
      findLocation,
      filterSurvey,
      form,
      setItem,
      addItem,
      clearItem,
      saveItem,
      areaSelect,
      locationSelect,
      zoneSelect,
      mobile,
      print,
      printAgain,
      mdAndUp,
      headerHtml,preview, compiledData ,
      tHeader__: computed(()=>state.tableHeaders)
    };
  }
});
